var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:( _obj = {}, _obj[_vm.$style.primary] = !_vm.reverse, _obj[_vm.$style.primaryReverse] = _vm.reverse, _obj ),attrs:{"disabled":_vm.disabled || _vm.loading,"type":_vm.type},on:{"click":_vm.click}},[_c('span',{class:_vm.$style.label},[(_vm.loading)?_c('loader',{class:_vm.$style.loader}):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }